import { render, staticRenderFns } from "./w-services-quiz.vue?vue&type=template&id=fa6935aa"
import script from "./w-services-quiz.vue?vue&type=script&lang=js"
export * from "./w-services-quiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports